import { render, staticRenderFns } from "./DormTabNavBranch.vue?vue&type=template&id=bb791134&scoped=true&"
import script from "./DormTabNavBranch.vue?vue&type=script&lang=js&"
export * from "./DormTabNavBranch.vue?vue&type=script&lang=js&"
import style0 from "./DormTabNavBranch.vue?vue&type=style&index=0&id=bb791134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb791134",
  null
  
)

export default component.exports